import type { GroupByField } from '~domains/commerce/dashboard/entities/summary';

import { useIsDesktop } from '~shared/lib/responsive';
import { MobileSelect } from '~shared/ui/mobile-select';

import { Chips } from '@breezeventures/ui-kit/chips';
import { Typography } from '@breezeventures/ui-kit/typography';

const GROUP_BY_OPTIONS: { value: GroupByField; label: string }[] = [
  { value: 'by-merchant', label: 'Business' },
  { value: 'by-pos', label: 'Store' },
];

type Props = {
  value: GroupByField;
  onChange: (value: GroupByField) => void;
};

export const GroupBySwitch = ({ value, onChange }: Props) => {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return (
      <MobileSelect
        options={GROUP_BY_OPTIONS}
        value={value}
        onChange={onChange}
        triggerPrefix="Group by"
      />
    );
  }

  return (
    <div className="flex flex-1 items-center justify-between gap-4">
      <Typography.Title size="xs" tag="h3">
        Group by
      </Typography.Title>
      <Chips
        type="single"
        variant="soft"
        size="m"
        value={value}
        onChange={(next) => onChange(next as GroupByField)}
      >
        {GROUP_BY_OPTIONS.map((option) => (
          <Chips.Item key={option.value} value={option.value}>
            {option.label}
          </Chips.Item>
        ))}
      </Chips>
    </div>
  );
};
